import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import MDTypography from "components/MDTypography";

/**
 * <ArticleFields> — the Article type block. WSF articles are frequently
 * reshared news; `source_url` records the original article so the site can
 * credit and link back to it. Shown for every article.
 */
function ArticleFields({ value, onChange }) {
  return (
    <Stack spacing={3}>
      <MDTypography variant="button" fontWeight="bold" textTransform="uppercase" color="text">
        Article details
      </MDTypography>

      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(value.is_featured)}
            onChange={(e) => onChange({ is_featured: e.target.checked })}
          />
        }
        label="Featured article"
      />

      <TextField
        label="Source URL"
        type="url"
        value={value.source_url}
        onChange={(e) => onChange({ source_url: e.target.value })}
        fullWidth
        helperText="Optional — link to the original article when this is reshared news"
      />
    </Stack>
  );
}

ArticleFields.defaultProps = {
  websiteId: undefined,
  context: {},
};

ArticleFields.propTypes = {
  value: PropTypes.shape({
    is_featured: PropTypes.bool,
    source_url: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  websiteId: PropTypes.string,
  context: PropTypes.object,
};

export default ArticleFields;
